// Packages
import { useTheme } from "@mui/material/styles";

// MUI
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";

// components
import { MenuSelect } from 'components/Select/menuSelect';
import { StyledLabel } from '../StyledLabel';

export const StyledMenuSelect = ({
  width,
  showEditGeneral,
  options,
  label,
  value,
  isIndent = false,
  isPro = false,
  placeholder,
  onChange
}) => {
  const theme = useTheme();

  return (
    <StyledLabel
      {...{
        label,
        isIndent,
        isPro,
        isProEnabled: value !== "DISABLED" && Boolean(value),
      }}
    >

      <MenuSelect
        disabled={!showEditGeneral}
        width={width}
        placeholder={placeholder || ""}
        value={value}
        onChange={opt => onChange(opt)}
        options={options}
      />

    </StyledLabel>
  );
};